import React, { useEffect } from 'react';
import {
  CssBaseline,
  ThemeProvider
} from '@mui/material';
import Header from "../src/containers/Header/header"
import HeaderDafaplus from "../src/containers/Header/HeaderDafaplus"
import Frame from './containers/Frame/Frame';
import NotFound from './containers/NotFound/NotFound';
import {
  defaultTheme,
  nextBetThemeWithFonts,
  zedBetThemeWithFonts,
  fTVThemeWithFonts,
  babyThemeWithFonts,
  jamboreeThemeWithFonts,
  zipangThemeWithFonts,
  spinmileThemeWithFonts,
  mswThemeWithFonts
} from "./theme/theme";
import AutoSignIn from '../src/containers/AutoSignIn/AutoSignIn'
import { getUrlParam } from './utils/common';
import { decodeMParam } from './utils/jwtUtils';
import Call from '../src/containers/Call/call';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HealthCheck from './containers/HealthCheck/HealthCheck';
import Voice from './containers/Call/Voice';
import seven77babyIco from './assets/777baby.ico';
import dafabetsIco from './assets/dafabet.ico';
import ftvIco from './assets/ftv.ico';
import jamboreeIco from './assets/jamboree.ico';
import nextbetIco from './assets/nextbet.ico';
import nextbetBrazilIco from './assets/nextbet-brazil.ico';
import zedbetIco from './assets/zedbet.ico';
import zipangIco from './assets/zipang.ico';
import spinmileIco from './assets/spinmiles.ico';
import mswIco from './assets/msw.ico';
interface AppProps {
  brand: string; // Accept brand as prop
  lang: string;  // Accept lang as prop
}
const faviconMap: Record<string, string> = {
  "sevenbaby": seven77babyIco,
  "dafabet": dafabetsIco,
  "ftv": ftvIco,
  "jamboree": jamboreeIco,
  "nextbet": nextbetIco,
  "nextbet-brazil": nextbetBrazilIco,
  "zedbet": zedbetIco,
  "zipang": zipangIco,
  "spinmile": spinmileIco,
  "msw": mswIco,
};
const titleMap: Record<string, string> = {
  "nextbet": "Nextbet Chat",
  "dafabet": "Dafabet Chat",
  "zedbet": "Zedbet Chat",
  "sevenbaby": "777Baby Chat",
  "ftv": "FTV Chat",
  "jamboree": "Casino Jamboree Client JP",
  "nextbet-brazil": "Nextbet Brazil Chat",
  "zipang": "Zipang Japan",
  "spinmile": "Spinmile Chat",
};

const usePageMetadata = (brand: string, lang: string) => {
  useEffect(() => {
    const brandLower = brand?.toLowerCase() || "";
    const langLower = lang?.toLowerCase() || "";

    document.title = titleMap[brandLower] || "Web Chat";

    let faviconKey = brandLower;
    if (brandLower === "nextbet" && langLower === "pt") {
      faviconKey = "nextbet-brazil";
    }

    const faviconFile = faviconMap[faviconKey] || faviconMap["dafabet"];

    const faviconUrl = `${faviconFile}?v=${Date.now()}`;

    const favicon = document.getElementById("dynamic-favicon") as HTMLLinkElement | null;
    if (favicon) {
      favicon.href = faviconUrl;
      favicon.type = "image/x-icon";
      console.log(`✅ Favicon set for ${brandLower} (${langLower}): ${favicon.href}`);
    } else {
      console.warn("⚠️ Favicon element not found in index.html");
    }
  }, [brand, lang]);
};



function App({ brand, lang }: AppProps) {
  const location = useLocation();
  
  // Get and decode the m parameter
  const encryptedMParam = getUrlParam('m');
  let mParam = null;
  let mUsername = null;
  let mEmail = null;
  let mReferer = null;
  
  // Only try to decode if m parameter exists
  if (encryptedMParam) {
    try {
      const decodedData = decodeMParam(encryptedMParam);
      if (decodedData) {
        mParam = decodedData.msg || null;
        mUsername = decodedData.username || null;
        mEmail = decodedData.email || null;
        mReferer = decodedData.referer || null;
      }
    } catch (error) {
      console.error('Error processing m parameter:', error);
    }
  }
  
  // Determine if this is a proactive chat
  const isProactive = Number(getUrlParam('proactive')) === 1 || encryptedMParam !== null;

  console.log('🔍 App routing debug:', {
    encryptedMParam,
    proactiveParam: getUrlParam('proactive'),
    isProactive,
    pathname: location.pathname,
    mParam,
    mUsername,
    mEmail,
    mReferer
  });
  
  usePageMetadata(brand || "dafabet", lang || "en");
  const brandKey = brand?.toLowerCase();
  const isNextBet = brand?.toLowerCase() === 'nextbet';
  
  const themeMap: Record<string, any> = {
  nextbet: nextBetThemeWithFonts,
  zedbet: zedBetThemeWithFonts,
  ftv: fTVThemeWithFonts,
  sevenbaby: babyThemeWithFonts,
  zipang: zipangThemeWithFonts,
  jamboree: jamboreeThemeWithFonts,
   spinmile: spinmileThemeWithFonts,
   msw: mswThemeWithFonts,
};

let theme = brandKey && themeMap[brandKey] ? themeMap[brandKey] : defaultTheme;


  if (isNextBet && lang.toLocaleLowerCase()==='pt') {
    theme = defaultTheme;
  }

  const isNotFound = location.pathname === "*";
  const isDafaplus = brand?.toLowerCase() === 'dafaplus';

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!isNotFound && (isDafaplus ? <HeaderDafaplus /> : <Header />)} {/* Conditionally render Header */}
      <Routes>
        <Route path='/webchat/v3/call/:language/:brand' element={<Voice />} />
        <Route
          path="/webchat/v3/chat/:language/:brand"
          element={
            isProactive ? (
              <AutoSignIn
                mParam={mParam}
                mUsername={mUsername}
                mEmail={mEmail}
                mReferer={mReferer}
              />
            ) : (
              <Frame brand={brand} />
            )
          }
        />
        <Route path="/webchat/v3/health" element={<HealthCheck />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
